export default __webpack_public_path__ + "static/VedettaOrig-379ca67c3a47b17a2b02d8872bd16af3.jpg";